// extracted by mini-css-extract-plugin
module.exports = {"root":"tabs_full_root__17C4r"};